const Endpoints = {
  //Auth
  publicKey: "/auth/public-key",
  login: "/admin/login",
  verifyOtp: "/admin/login/verify-otp",
  resendOtp: "/admin/login/resend-otp",
  refresh: "/auth/refresh",
  logout: "/auth/logout",
  forgotPassword: "/admin/user/forgotPassword",
  resetPassword: "/admin/user/resetpassword",
  // getSilverList: `/admin/user/api/v1/silverRates/list?page=1&size=10`,
};

const goldRateModule = {
  getSilverList: `/silverRates/list`,
  getGoldList: `/rates/list`,
  refreshRates: `/rates/refresh`,
  recentRate: `/rates/recentrate`,
  getRateById: `/rates/getRateById`,
  createRate: `/rates/create`,
  updateRate: `/rates/update`,
  deleteRate: `/rates/delete`,
};

const schemeModule = {
  getAllMasterSchemes: "/scheme/api/v1/schemes",
  createMasterScheme: `/scheme/api/v1/schemes`,
  upload: `/schemes/upload`,
  subSchemes: `/subscheme`,
  viewMaster: "/schemes",
  exportCsv: "/passbook/export/csv",
  sampleCsv: "/userScheme/generate_csv/bulkUpload",
  getAllUserScheme: "/userScheme/getAllUserScheme",
  downloadPdf: "/pdf/pdfDetail",
  passbookreceiptsynk: "/user/passbookReceiptSyncFromGpp",
  prodtopreprodsync: "/user/prodUsersSynctesting",
  getCountPassbook: "/userScheme/user/referral-active-passbook",
};

const getCustomer = {
  getCustomerList: `/user`,
  searchCustomer: `/user/search`,
};

const customerModule = {
  getScheme: `/userScheme`,
  getProfile: `/user/internal/get-user`,
  editProfile: `/user`,

  getGppInfo: `/user/gpp-info`,
  getKyc: `/kyc`,
  bankDetail: `/bank_detail`,
  transactionLog: `/payment/user/transactionList`,
  sessionLog: `/log`,
  securityLog: `/log?type=security&userId=639ffc43a593ff8d0a7bbcf9`,
  transactionList: `/passbook`,
  payment: `/payment`,
  customerCount: `/userModal/customers-count`,
  showroomList: `/showroom`,
  getSchemeSearch: `/userScheme/search-user`,
  // redeemDetails: "/userScheme/redeem-details",
  uploadProfile: `/user/upload`,
  getSchemeDetails: "/userScheme/getUserSchemeById",
  updateEngagementConfig: "/user/update/engament-config",

  rewardsList: "/reward",
  getSessionDetails: "/log/getsessionDetail",
  updatepassbookUserScheme: "/userScheme/internal/updateUserScheme",
  address: "/address",
  updateBPNameFromGPP: "/userScheme/userSchemeNameSync-fromgpp",
  pinCode: `/address/pincode`,
  syncpassbookfromGpp: "/user/passbookSyncFromGpp",
  getuserSchemeGift: "/userScheme/userSchemeGift",
  mandate: "/user/schedulePay/mandateDetails",
  cancelMandate: "/payment/cancelPayToken",
  retryMandate: "/payment/createScheduleOrder",
  tickets: (email) => `/zendesk/getticket/ticket requester:${email}`,
};

const userModule = {
  addrole: "/admin/role",
  addStaff: "/admin/user/create",
  updateStaff: "/admin/user/update",
  addDepartment: "/admin/department",
  getAllUser: `/admin/user/list`,
  userresetPassword: `/admin/user/resetpassword`,
};

const settings = {
  profileUpdate: "/admin/user/update",
  changePassword: "/admin/change-admin-password",
  getProfile: "/admin/get-profile",
};

const contentManagementModule = {
  messageModals: "/content?section=message",
  screenContent: "/content?section=content",
  landingPages: "/content?section=page",
  contentHome: "/content?section=home",
  orderConfirmation: "/content",
  banner: "/content/banner/list",
  updateBanner: "/content/banner",
  deleteBanner: "/content/banner",
  getContentDetails: "/content/getContentById",
  updateBannerPosition: "/content/banner/update-position",
};

const workManagementModule = {
  getWorkFlowList: "/workflow",
  // getWorkFlowListExport:'/workflow',
  bulkUpload: "/workflow/createMany/workflow",
  bannerDetails: "/content/banner/getBannerById",
  addReason: "/workflow/createreason",
  getReason: "/workflow/reason/getreason",
  deleteReason: "/workflow/reason/deletereason",
};

const orderManagementModule = {
  getOrdersist: "/order/getOrderList",
};

const systemConfigSettingsModule = {
  showroom: "/showroom",
  configUpdate: `/config`,
  languages: `/mobileContents/language/list`,
  language: `/mobileContents/language`,
  mobileStaticContent: "/mobileContents/createManymobileContent",
  mobileContents: "/mobileContents",
  versionHistory: "/workflow/versionhistory",
  typedropdown: "/mobileContents/getTypes",
  getpayload: "/passbook/payloadsearch",
  typeOptions: "/passbook/payloadtype"

};

const reportModule = {
  getUserSchemeCount: "/userScheme/userSchemeCount",
  getPaymentExport: "/admin/export/payment",
  getUserExport: "/admin/export/user",
  getSchemeCollectionReport: "/admin/schemeCollectionReport",
  getRedemptionReport: "/admin/schemeBalanceReport",
  downloadExcel: `/admin/download`,
  getRedemptionReportExport: `/admin/export/schemesReport`,
  getRegistrationSummary: "/user/userData",
  getCustomerBalanceReport: "/admin/customerBalanceReport",
  getPassbookStatementReport: "/admin/customerPassbooksReport",
  getPassbookDetailReport: "/admin/passbookDetailsReport",
  getPassbookDetailReportExport: "/admin/export/passbookDetailReport",
  getSubScheme: "/subscheme",
  501: "/admin/monthlySummaryBalanceReport",
  502: "/admin/monthlySummaryCollectionReport",
  503: "/admin/dailySummaryCollectionReport",
  504: "/admin/schemewiseDailySummaryReport",
  701: "/campaign/rewardReport",
  702: "/campaign/rewardConversionReport",
  703: "/campaign/rewardTracking",
  704: "/campaign/sgs-8-reward",
  userKycReport: "/user/kyc",
  regitrationTrend: "/user/regitrationTrend",
  conversionTrend: "/user/conversionTrend",
  joiningTrend: "/user/joiningTrend",
  redemptionTrend: "/user/redemptionTrend",
  dueCollectionTrend: "/user/dueCollectionInstallmentTrend",
  dueCollectionAmountTrend: "/user/dueCollectionAmountTrend",
  targetCollectionTrend: "/user/targetCollectionTrend",
  schemeBalance: "/user/schemeBalance",
  consolidatedDailySummary: "/user/dailySummary",
  digiGoldReceiptPattern: "/user/digiGold/receiptPattern",
  digiGoldBalancePattern: "/user/digiGold/balancePattern",
  digiGoldRedemptionPattern: "/user/digiGold/redemptionPattern",
  superGoldReceiptPattern: "/user/superGold/receiptPattern",
  superGoldBalancePattern: "/user/superGold/balancePattern",
  superGoldRedemptionPattern: "/user/superGold/redemptionPattern",
  superGoldInstallmentPattern: "/user/superGold/installmentPattern",
  superGoldDuesPattern: "/user/superGold/duePattern",
  superGoldDelayPattern: "/user/superGold/delayPattern",
  getPosReport: "/admin/posReport",
  verifyEmailReport: "/user/verifiedEmailReport",
  customerReview: "/user/customerReview",
  panAdharReport: "/user/kycUpdation",
  zeroBounceReport: "/user/zerobounce",
  surepasslogs: "/user/surepasslogs",
  callbackRequestReport: "/user/callback-request",
  customer_profile_report: "/user/customer-profile",
  datadeletionreport: "/user/customer-delete",
  subhkshamReport: "/admin/lead/subiksham",
  sponcer: "/admin/lead/sponsor",
  maindownload: "/admin/download",
  getMandateReconciliation: "/passbook/mandateReconciliationPost",
  getMandatePresentedReport: "/user/schedulePay/mandatePresentReport",
  mandateReport: "/user/schedulePay/mandateReport",
  passbookDueReport: "/user/schedulePay/passbookDueReport",
  MISReport: "/dashboard/MISReport",
  modalPrompt: "/modalPrompt",
  modalPromptLogs: "/modalPrompt/logs",
};

const dashboard = {
  getDashboardSgsList: `/dashboard/dashboardsubscheme`,
  // Scheme dashboard endpoints
  lockYourGoldToday: "/dashboard/lockYourGoldToday",
  lockYourGoldTodayChart: "/dashboard/lockYourGoldTodayChart",
  lockYourGoldTotal: "/dashboard/lockYourGoldTotal",
  lockYourGoldMatured: "/dashboard/lockYourGoldMatured",
  digisilverToday: "/dashboard/digisilverToday",
  digiSilverTodayChart: "/dashboard/digiSilverTodayChart",
  digiSilverTotal: "/dashboard/digiSilverTotal",
  digiSilverMatured: "/dashboard/digiSilverMatured",
};
export const modalPromts = {
  list: "/modalprompt",
  create: "/modalprompt/createmodal",
  update: "/modalprompt",
  delete: "/modalprompt",
};

const referralManagementCatgoryModule = {
  getCategoryListNoDropdown: "/category/dropDownList",
  getCategoryList: "/category",
  getApplicant: "/referral",
  updatedCategory: "/category",
  createCategory: "/category",
  updateCategoryStatus: "/category/updateCategoryStatus",
  getAllCampaignList: "/campaign/getAllCampaignList",
};

const referralManagementApplicationInbox = {
  getApplicant: "/referral",
  updateApproval: "/referral/approval",
  applicantRejection: "/referral/reject",
};

const referralManagementAllUsers = {
  getApplicant: "/referral",
  userConvert: "/referral/convert",
  editUserApplication: "/referral/editApplicantForm",
  getUserList: "/referral/getUserList",
  editBankDetails: "/bank_detail",
  ExportFileAllication: "/referral/download",
};
const userTrackingInUsers = {
  getTracking: "/userCategoryTracking/getUserCategoryTracking",
};

const referralManagementCampaigns = {
  getCampaignList: "/campaign/getCampaignList",
  createCampaign: "/campaign/createCampaign",
  updatePauseCampaign: "/campaign/updateStatus",
  updateCampaign: "/campaign/updateCampaign",
  manualEvent: `/campaign/manual-buisnessEventTrigger`,
  duplicateCampaign: "/campaign/duplicateCampaign"
};

const referralManagementFaq = {
  getFaqList: "/faq",
  createFaq: "/faq",
  updateFaq: "/faq",
};

const deleteRequest = {
  getDeleteRequestList: "/deleterequest/deleteuserList",
  getDeleteRequest: "/deleterequest",
  downloaddelectionRequest: "/deleterequest/deleteuserListReport",
};

const receiptReconciliation = {
  getReceiptList: "/passbook/receiptReconciliation",
  cancelReceiptList: "/payment/initiateRefundPayment",
  generateReceiptList: "/passbook/generateReceipt",
};

const referralManagementReports = {
  getCampaignSummaryReport: "/campaign/campaignSummaryReport",
  getRewardReport: "/campaign/referralRewardReport",
  getApplicationProcessingReport: "/campaign/applicationProcessingReport",
  getUserActivityTrackerReport: "/campaign/userActivityTrackerReport",
  getActiveCampaignMediaAnalysis: "/campaign/campaignMediaAnalysisReport",
  getActiveUserSummaryTracker: "/campaign/userSummaryReport",
  getConversionReport: "/campaign/conversionReport",
  getActivePayoutReport: "/campaign/PayoutReport",
  getUserDashbord: "/campaign/newCampaignDashboardCount",
  userCampaignDashboardReport: "/campaign/userCampaignDashboardReport",
  campaignUserEarnings: "/campaign/campaignUserEarnings",
  userPayoutReport: "/campaign/userPayout",
  campaignConversion: "/campaign/campaignConversion",
  disbursmentPayout: "/campaign/disbursmentPayout",
  payoutUserLevelPayout: "/campaign/userLevelPayout",
  scheduleCampaignCronJobs: "/referPayout/scheduleCampaignCronJobs",
  schedulePayoutRequestToGPP: "/referPayout/schedulePayoutRequestToGPP",
  getmountaindata: "/campaign/liveCampaignDashboardBackgroundData",
};
const crmConfiguration = {
  getEventList: "/ozonetelevent/geteventcamp",
  createEventCamp: "/ozonetelevent/createeventcamp",
  updateEventCamp: "/ozonetelevent/updateeventcamp",
  deleteEventCamp: "/ozonetelevent/deleteeventcamp",
};

const crmAgent = {
  getAgentList: "/agentmap/getagentmap",
  createAgent: "/agentmap/createagentmap",
  updateAgent: "/agentmap/updateagentmap",
  deleteAgent: "/agentmap/deleteagentmap",
};

const zendeskgroup = {
  getGroupList: "/zendeskgroup/getzendeskgroup",
  createGroup: "/zendeskgroup/createzendeskgroup",
  updateGroup: "/zendeskgroup/updatezendeskgroup",
  deleteGroup: "/zendeskgroup/deletezendeskgroup",
};

const skillName = {
  getSkillName: "/skillmap/getskillmap",
  createSkillName: "/skillmap/createskillmap",
  updateSkillName: "/skillmap/updateskillmap",
  deleteSkillName: "/skillmap/deleteskillmap",
};

const crmUpload = {
  upload: "/ozonetel/uploadLeads",
  exportAgentMapping: "/agentmap/downloadagentmap",
};
const referralManagementEmployeManage = {
  employeGetData: `/employe`,
  employeEdit: `/employe`,
  employeUploadData: `/employe/createManyEmploye`,
};
export const mandateAuthpayment = {
  refundAuthPayment: "/payment/refundAuthPayment",
};
const APIMethods = {
  POST: "POST",
  GET: "GET",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
};

const endpoints = {
  dashboard,
  Endpoints,
  goldRateModule,
  schemeModule,
  getCustomer,
  customerModule,
  userModule,
  contentManagementModule,
  APIMethods,
  settings,
  systemConfigSettingsModule,
  workManagementModule,
  reportModule,
  orderManagementModule,
  referralManagementCatgoryModule,
  referralManagementApplicationInbox,
  referralManagementAllUsers,
  referralManagementCampaigns,
  referralManagementFaq,
  deleteRequest,
  receiptReconciliation,
  referralManagementReports,
  referralManagementEmployeManage,
  userTrackingInUsers,
  crmConfiguration,
  crmAgent,
  zendeskgroup,
  skillName,
  crmUpload,
  mandateAuthpayment,
  modalPromts
};

export default endpoints;
